// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1WxdF","content":"RecentSearches_content__2dDFH"};